import store from '@/store';
import { CheckoutSection } from './CheckoutV3.interfaces';
import { CheckoutStepType } from '@/store/checkout/types';
import { AnyProduct } from '@shared/interfaces/product';
import { ProductType } from '@/api/Cart/cart.interfaces';
import { isNotNil } from '@shared/utils/value';
import { AnyDefineComponent } from '@shared/interfaces/vue';
import { hasHotelProduct } from '@/helpers/cart';
import { AVAILABLE_SEMBONUS_MARKETS } from '@shared/config/market/market.mapping';
import { Market } from '@shared/config/market/market.models';
import Contact from './Sections/Contact/Contact.vue';
import Sembonus from './Sections/Sembonus/Sembonus.vue';
import Addons from './Sections/Addons/Addons.vue';
import Confirm from './Sections/Confirm/Confirm.vue';
import Activity from './Sections/Products/Activity/Activity.vue';
import Flight from './Sections/Products/Flight/Flight.vue';
import Ferry from './Sections/Products/Ferry/Ferry.vue';
import Hotel from './Sections/Products/Hotel/Hotel.vue';
import ServicePackage from './Sections/ServicePackage/ServicePackage.vue';

export function deleteState(id: string) {
    store.dispatch('checkout/deleteState', id);
}

export function getSections(): CheckoutSection[] {
    return [
        {
            sectionId: CheckoutStepType.Contact,
            section: { component: Contact },
        },
        ...getSectionProducts(),
        {
            sectionId: CheckoutStepType.ServicePackage,
            enabled: getSectionEnabled(CheckoutStepType.ServicePackage),
            section: { component: ServicePackage },
        },
        {
            sectionId: CheckoutStepType.Addons,
            enabled: getSectionEnabled(CheckoutStepType.Addons),
            section: { component: Addons },
        },
        {
            sectionId: CheckoutStepType.Sembonus,
            enabled: getSectionEnabled(CheckoutStepType.Sembonus),
            section: { component: Sembonus },
        },
        {
            sectionId: CheckoutStepType.Confirm,
            section: { component: Confirm },
        },
    ].filter((x) => x.enabled !== false);
}

export function getSectionProductId(
    productId: string,
    productType: ProductType
): CheckoutStepType {
    return `${CheckoutStepType.Product}${productType.toLowerCase()}_${productId}` as CheckoutStepType;
}

function getSectionProducts(): CheckoutSection[] {
    const products = store.getters['cart/getMainProducts'] as AnyProduct[];

    return products
        .map((p: AnyProduct) => {
            const component = getProductComponent(p.Type) as AnyDefineComponent;

            if (component) {
                return {
                    sectionId: getSectionProductId(p.Id, p.Type),
                    section: {
                        component,
                        props: {
                            productId: p.Id,
                        },
                    },
                } as CheckoutSection;
            }
        })
        .filter(isNotNil);
}

function getProductComponent(type: ProductType) {
    switch (type) {
        case ProductType.Activity:
            return Activity;
        case ProductType.Flight:
            return Flight;
        case ProductType.Ferry:
            return Ferry;
        case ProductType.Hotel:
            return Hotel;
        default:
            return undefined;
    }
}

function getSectionEnabled(type: CheckoutStepType): boolean {
    const addons = store.getters['cart/getAvailableAddons'];
    const trips = store.getters['checkout/getTransferTrips'];
    const market: Market = store.getters['general/getMarket'];
    const cart = store.state.cart.data;
    const servicePackageAddons = store.getters['cart/getServicePackageAddons'];

    switch (type) {
        case CheckoutStepType.Addons:
            return addons.length > 0 || trips.length > 0;
        case CheckoutStepType.ServicePackage:
            return servicePackageAddons.length > 0;
        case CheckoutStepType.Sembonus:
            return (
                hasHotelProduct(cart) && AVAILABLE_SEMBONUS_MARKETS.includes(market.number)
            );
        default:
            return true;
    }
}
